
export class GenDocAttachment {
    id = 0;
    name = "";
    sort = 0;
    data = "";
    genDocId = 0;
}